// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue'
import type { RouteRecordRaw } from 'vue-router';
import {roterPre} from "@/settings";

const stationRouter =
  {
    path:  roterPre+`/station`,
    name: 'station',
    meta: {
      icon: '',
      title: '站内消息'
    },
    alwaysShow: true,
    component: Layout,
    children: [
      {
        path: 'notice/:id?',
        name: 'stationNotice',
        meta: {
          title: '站内消息'
        },
        component: () => import('@/views/station/notice/index.vue')
      }
    ]
  }

export default stationRouter as RouteRecordRaw